<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  isWhatsAppType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'edit',
  'delete',
  'retryFailed',
  'viewRecipients',
  'pause',
  'resume',
  'stop',
  'resumeMeta',
]);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleRetryFailed = campaign => emit('retryFailed', campaign);
const handleViewRecipients = campaign => emit('viewRecipients', campaign);
const handlePause = campaign => emit('pause', campaign);
const handleResume = campaign => emit('resume', campaign);
const handleStop = campaign => emit('stop', campaign);
const handleResumeMeta = campaign => emit('resumeMeta', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :campaign-id="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :is-whats-app-type="isWhatsAppType"
      :delivery-statistics="campaign.delivery_statistics"
      :retry-failed-url="campaign.retry_failed_url"
      :delivery-recipients-url="campaign.delivery_recipients_url"
      :retry-source-campaign-id="campaign.retry_source_campaign_id"
      :stop-url="campaign.stop_url"
      :stopped-at="campaign.stopped_at"
      :meta-paused-at="campaign.meta_paused_at"
      @edit="handleEdit(campaign)"
      @pause="handlePause(campaign)"
      @resume="handleResume(campaign)"
      @stop="handleStop(campaign)"
      @resume-meta="handleResumeMeta(campaign)"
      @delete="handleDelete(campaign)"
      @retry-failed="handleRetryFailed(campaign)"
      @view-recipients="handleViewRecipients(campaign)"
    />
  </div>
</template>
